import { useQuery } from "@tanstack/react-query";
import { prependKasUrl, KAS_HOST, redirectUserToLogin } from "../utils";
import { useLocation } from "react-router-dom";
import { isPublicRoute } from "SecuredRoute/isPublicRoute";
import {
  setPostLoginRedirect,
  shouldPersistPostLoginRedirect,
} from "utils/redirects";

export type UserContextResponse = {
  name: string;
  orgName: string;
  userId: string;
  email: string;
  picture?: string;
};

export const useGetContext = () => {
  const location = useLocation();
  const queryKey = "/user-context";
  const persistPostLoginRedirect = () => {
    if (shouldPersistPostLoginRedirect(location.pathname)) {
      setPostLoginRedirect(location.pathname + location.search);
    }
  };

  return useQuery({
    queryFn: async (): Promise<UserContextResponse> =>
      fetch(prependKasUrl(queryKey), {
        headers: { host: KAS_HOST },
        credentials: "include",
        method: "GET",
      })
        .then(async (response) => {
          if (response.ok) {
            return await response.json();
          } else if (location.pathname.includes("/launchable/deploy/now")) {
            const searchParams = new URLSearchParams(location.search);
            //forceLogin=true is used to force the user to login before redirecting to the launchable deploy page
            if (!!searchParams.get("forceLogin")) {
              persistPostLoginRedirect();
              redirectUserToLogin();
            } else {
              window.location.href = `${location.pathname.replace(
                "/launchable/deploy/now",
                "/launchable/deploy",
              )}${location.search}`;
            }
          } else {
            if (!isPublicRoute(location.pathname)) {
              persistPostLoginRedirect();
              redirectUserToLogin();
            }
          }
          return {};
        })
        .catch((error) => {
          console.error(error);
          persistPostLoginRedirect();
          redirectUserToLogin();
          return {};
        }),
    queryKey: [queryKey],
    refetchInterval: 10_000,
    refetchIntervalInBackground: true, // ensure the tokens are refreshed in KAS even when the tab/window is in the background - otherwise user may run into auth issues after minimizing the window and coming back.
  });
};
